import { SearchCollectionConfig } from "../types/context";

/**
 * Fetches search suggestions from the Funnelback suggest endpoint.
 * @param config - Search collection config (endpoint base + collection)
 * @param partialQuery - Current query fragment typed by the user
 * @returns Promise resolving to an array of suggestion strings
 */
export const fetchSuggest = async (
    config: SearchCollectionConfig,
    partialQuery: string
): Promise<string[]> => {
    const { endpoint, collection, profile } = config;
    if (!endpoint?.trim() || !collection?.trim()) {
        return [];
    }

    try {
        const url = new URL(endpoint);
        url.pathname = url.pathname.replace(
            /\/search\.json$/i,
            "/suggest.json"
        );
        url.searchParams.set("collection", collection);
        url.searchParams.set("partial_query", partialQuery.trim());
        if (profile?.trim()) {
            url.searchParams.set("profile", profile);
        }

        const response = await fetch(url.href);
        if (!response.ok) {
            return [];
        }

        const data = await response.json();
        if (!Array.isArray(data)) {
            return [];
        }

        return data.filter(
            (item: unknown): item is string =>
                typeof item === "string" && item.trim() !== ""
        );
    } catch {
        /* Network error, CORS, or invalid URL – return no suggestions */
        return [];
    }
};
